module.exports = __webpack_public_path__ + "static/media/companyLogo6.e7e00249.png";